<h1 mat-dialog-title>{{ (isEditMode ? 'properties.remappings.editTitle' : 'properties.remappings.addTitle') | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 col-md-6 text-left">
          <a mat-button (click)="onDenial()" mat-raised-button mat-default class="ml-3">{{ 'common.cta.close' | translate }}</a>
        </div>
        <div class="col-12 col-md-6 text-right">
          <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate">
          </mat-spinner-button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
